/* eslint-disable @typescript-eslint/no-explicit-any */
import { type Property } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import { getPath } from '@/utils/next-util'
import ImageOptimize from '../ImageOptimize'
import { FilterGroup } from './FilterGroup'

interface FilterHighlightType {
  className?: string
  filterGroup: Property
  onChange: (params: any) => void
  activeFilters: {
    name: string
    values: string[]
  }[]
}

export const FilterHighlight = ({
  className,
  filterGroup,
  activeFilters = [],
  onChange = () => true,
}: FilterHighlightType) => {
  return (
    <div
      className={`flex w-full flex-row flex-wrap gap-x-2.5 gap-y-1.5 text-center  text-sm ${className}`}
    >
      {filterGroup.values.length > 0 &&
        filterGroup.values.map((t, index) => (
          <FilterGroup
            type='button'
            className='mb-1.5'
            key={`quick-${index}`}
            option={t}
            activeOption={activeFilters.find(
              (f: any) => f.name === getPath(filterGroup.slugs)
            )}
            onChange={onChange}
          >
            {t.image ? (
              <ImageOptimize
                className='h-5 w-auto rounded-lg object-cover !p-0'
                src={t.image}
                alt={getTranslate(t.value)}
                width={240}
                height={100}
              />
            ) : (
              <span className='inline-block text-center  text-sm capitalize'>
                {getTranslate(t.value)}
              </span>
            )}
          </FilterGroup>
        ))}
    </div>
  )
}
